/**
 * [#e03fdbc2] Партнёры для бегущей строки. Список дал владелец 04.11.2026.
 * Убраны тестовые и странные записи, личные имена, дубли и учётки без постановок.
 */
export const TRUSTED_PARTNERS = [
  'Muddat', 'Fursat', 'Texnomarkaz', 'Texnomarket', 'Probox', 'MEINHAUS', 'TAQSEET', 'ISTYLE PLUS', 'SEMSTORE', 'Kingsman',
  'Belvest', 'Prime Mobile', 'Mix Mobile', 'Sheyx Mobile', 'Vekki Pro', 'Life-Tech', 'Hokt', 'Nasiya Savdo', 'Oson Mobile',
  'MACONE', 'buyPRO', 'City Point', 'Apple Garden', 'TEK Phones', 'Aligned Tech', 'MarketsNG', 'IMCO Digital',
  'Omanbelryn Easy Connect', 'GetMobi', 'Ezgutech', 'Brocenter', 'Friends Store',
];
